import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Routes, RouterModule } from '@angular/router';
import { SharedModule } from '../shared/shared.module';
import { ToastModule } from 'primeng/toast';
import { DropdownModule } from 'primeng/dropdown';
import { CalendarModule } from 'primeng/calendar';
import { DialogModule } from 'primeng/dialog';
import { MultiSelectModule } from 'primeng/multiselect';
import { NgxPaginationModule } from 'ngx-pagination';
import { AgGridAngular, AgGridModule } from 'ag-grid-angular';
import 'ag-grid-enterprise';

// Components
import { PortalComponent } from './portal.component';
import { ReportListComponent } from './report-list/report-list.component';
import { ReportListViewComponent } from './report-list/report-list-view/report-list-view.component';
import { DashboardListComponent } from './dashboard-list/dashboard-list.component';
import { DataEntryComponent } from './data-entry/data-entry.component';
import { PreviewFieldComponent } from './data-entry/preview-field/preview-field.component';
import { FieldComponent } from './field/field.component';
import { DatasheetCalendarComponent } from './field/datasheet-calendar/datasheet-calendar.component';
import { TopBarComponent } from './field/top-bar/top-bar.component';
import { ViewDatasheetComponent } from './datasheet/view-datasheet/view-datasheet.component';
import { MoveRunTicketDateComponent } from './datasheet/run-ticket/move-run-ticket-date/move-run-ticket-date.component';
import { JumpToDatasheetComponent } from './datasheet/jump-to-datasheet/jump-to-datasheet.component';
import { NavViewDatasheetComponent } from './datasheet/nav-view-datasheet/nav-view-datasheet.component';
import { ViewTankGaugesComponent } from './datasheet/view-tank-gauges/view-tank-gauges.component';
import { ImportTicketsComponent } from './datasheet/run-ticket/import-tickets/import-tickets.component';
import { WellSelectComponent } from './well-files/well-select/well-select.component';
import { WellFilesComponent } from './well-files/well-files.component';
import { AddWellFileComponent } from './well-files/add-well-file/add-well-file.component';
import { AttachmentsComponent } from './well-files/attachments/attachments.component';
import { FileUploadComponent } from './well-files/attachments/file-upload/file-upload.component';
import { FileViewEditComponent } from './well-files/attachments/file-view-edit/file-view-edit.component';
import { ImagesComponent } from './well-files/attachments/images/images.component';

// Services
import { QueryFilterPipe } from './_pipes/query-filter.pipe';
import { PowerbiViewerComponent } from './powerbi-viewer/powerbi-viewer.component';
import { PowerBIAuthenticationService } from './_services/powerbi-authentication.service';
import { ReportFavoriteService } from './_services/report-favorite-service';

// Pipes
import { FieldSortByPipe } from './_pipes/field-sort.pipe';
import { FieldQueryFilterPipe } from './_pipes/field-query-filter.pipe';
import { TicketSortByPipe } from './_pipes/ticket-sort.pipe';
import { TicketQueryFilterPipe } from './_pipes/ticket-query-filter.pipe';
import { BatteryFilterPipe } from './_pipes/battery-filter.pipe';
import { TankFilterPipe } from './_pipes/tank-filter.pipe';
import { ClassFilterPipe } from './_pipes/class-filter.pipe';
import { FileSizePipe } from './_pipes/file-size.pipe';
import { DivisionPipe } from './_pipes/division.pipe';
import { ReportSortByPipe } from './_pipes/report-sort.pipe';
import { ReportQueryFilterPipe } from './_pipes/report-query-filter.pipe';
import { ReportGroupFilterPipe } from './_pipes/report-group-filter.pipe';
import { ReportGroupQueryFilterPipe } from './_pipes/reportgroup-query-filter.pipe';

const appRoutes: Routes = [
  {
    path: '',
    component: PortalComponent,
    children: [
      //{ path: '', redirectTo: 'reports-test', pathMatch: 'full' },
      {
        path: 'reportlist',
        component: ReportListComponent
      },
      {
        path: 'dashboardlist',
        component: DashboardListComponent
      },
      {
        path: 'wellfiles',
        component: WellSelectComponent
      },
      {
        path: 'wellfiles/:wellId',
        component: WellFilesComponent
      },
      //{
      //  path: 'dataentry',
      //  component: DataEntryComponent
      //},
      //{
      //  path: 'bulkedit',
      //  component: DataEntryComponent
      //},
      //{
      //  path: 'dataentry/field/:fieldID',
      //  component: FieldComponent
      //},
      //{
      //  path: 'dataentry/field/:fieldID/datasheet/:datasheetID/entrydate/:entryDate/run-tickets',
      //  component: ViewDatasheetComponent
      //},
      //{
      //  path: 'dataentry/field/:fieldID/datasheet/:datasheetID/entrydate/:entryDate/tank-gauges',
      //  component: ViewTankGaugesComponent
      //},
      //{
      //  path: 'bulkedit/field/:fieldID/run-tickets',
      //  component: TopBarComponent
      //},
      {
        path: 'dashboard/view',
        component: PowerbiViewerComponent
      },
      { path: '**', redirectTo: 'reportlist' }
    ]
  }
];

@NgModule({
  declarations: [
    PortalComponent,
    ReportListComponent,
    ReportListViewComponent,
    QueryFilterPipe,
    DashboardListComponent,
    PowerbiViewerComponent,
    DataEntryComponent,
    PreviewFieldComponent,
    FieldComponent,
    DatasheetCalendarComponent,
    TopBarComponent,
    ViewDatasheetComponent,
    MoveRunTicketDateComponent,
    JumpToDatasheetComponent,
    FieldSortByPipe,
    FieldQueryFilterPipe,
    TicketSortByPipe,
    TicketQueryFilterPipe,
    BatteryFilterPipe,
    TankFilterPipe,
    ClassFilterPipe,
    FileSizePipe,
    DivisionPipe,
    NavViewDatasheetComponent,
    ViewTankGaugesComponent,
    ImportTicketsComponent,
    WellSelectComponent,
    WellFilesComponent,
    AddWellFileComponent,
    AttachmentsComponent,
    FileUploadComponent,
    FileViewEditComponent,
    ImagesComponent,
    ReportSortByPipe,
    ReportQueryFilterPipe,
    ReportGroupFilterPipe,
    ReportGroupQueryFilterPipe
  ],
  imports: [
    CommonModule,
    RouterModule.forChild(appRoutes),
    SharedModule,
    ToastModule,
    DropdownModule,
    CalendarModule,
    DialogModule,
    MultiSelectModule,
    NgxPaginationModule,
    AgGridAngular,
    AgGridModule
  ],
  exports: [
    RouterModule,
    FieldSortByPipe,
    FieldQueryFilterPipe,
    TicketSortByPipe,
    TicketQueryFilterPipe,
    BatteryFilterPipe,
    TankFilterPipe,
    ClassFilterPipe,
    FileSizePipe,
    DivisionPipe,
    ReportSortByPipe,
    ReportQueryFilterPipe,
    ReportGroupFilterPipe,
    ReportGroupQueryFilterPipe
  ],
  providers: [
    PowerBIAuthenticationService,
    ReportFavoriteService
  ]
})
export class PortalModule { }
